import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import ProductTimerButtons from 'components/ProductTimerButtons';
import WorkLogs from 'components/WorkLogs';
import QualityControlFeedback from 'components/QualityControlFeedback';
import ProductDetailsSection from 'components/ProductDetailsSection';
import LoadingSpinner from 'components/LoadingSpinner';
import {Section} from 'components/layouts';
import {refreshProduct} from 'ducks/productDetail';
import {productType, workLogsType, qualityControlType} from 'propTypes/products';
import {userType} from 'propTypes/accounts';
import {fetchWorkLogs} from 'ducks/workLogs';
import {fetchFeedback} from 'ducks/qualityControl';
import {USER_LANG} from 'utils/locale';
import {gettext} from 'utils/text';
import {WORKERS} from 'constants/accounts';
import ErrorAlert from './ErrorAlert';


class ProductDetails extends React.Component {
    static propTypes = {
        product: productType,
        userId: PropTypes.number.isRequired,
        error: PropTypes.string,
        isLoading: PropTypes.bool,
        workLogs: workLogsType.isRequired,
        showAddWorker: PropTypes.bool.isRequired,
        fetchWorkLogs: PropTypes.func.isRequired,
        refreshProduct: PropTypes.func.isRequired,
        fetchFeedback: PropTypes.func.isRequired,
        qualityControl: qualityControlType.isRequired,
        match: PropTypes.shape({}),
        workers: PropTypes.arrayOf(userType).isRequired,
    };

    static defaultProps = {
        product: null,
        error: null,
        isLoading: null,
        match: null,
    };

    componentDidMount() {
        const productId = this.getProductId();
        this.props.refreshProduct(productId);
        this.props.fetchWorkLogs(productId, this.props.userId);
        this.props.fetchFeedback(productId);
    }

    // eslint-disable-next-line react/prop-types
    getProductId = () => parseInt(this.props.match.params.id, 10);

    renderTimerButtons = () => (
        <Section>
            <ProductTimerButtons
                productId={this.getProductId()}
                showAddWorker={this.props.showAddWorker}
                workers={this.props.workers}
                workLogsLoading={this.props.workLogs.isLoading}
                workLogsError={this.props.workLogs.error}
                workLogGroups={this.props.workLogs.groups}
                activeWorkLogGroups={this.props.workLogs.activeGroups}
            />
        </Section>
    );

    renderComponent = components => (
        <tr key={components.id}>
            <td>
                {components.name}
            </td>
            <td>
                {components.quantity}
            </td>
            <td>
                {components.profit_id}
            </td>
        </tr>
    );

    renderNoComponent = () => (
        <tr>
            <td colSpan={3} className="text-center lead py-3">
                {gettext("No components added!")}
            </td>
        </tr>
    );

    renderComponents = (product) => {
        const striped = product.components.length > 3 ? 'table-striped' : '';
        return (
            <Section title={gettext('Components')}>
                <div className="table-responsive">
                    <table className={`table table-sm table-hover ${striped}`}>
                        <thead>
                            <tr>
                                <th>{gettext("Name")}</th>
                                <th>{gettext("Quantity")}</th>
                                <th>{gettext("Profit ID")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {product.components.map(this.renderComponent)}
                            {!product.components.length ? this.renderNoComponent() : null}
                        </tbody>
                    </table>
                </div>
            </Section>
        );
    };

    renderNavbar = () => {
        let text = gettext("Loading");
        if (this.props.error) {
            text = gettext('Error');
        } else if (!this.props.isLoading && this.props.product) {
            text = this.props.product.article_name;
        }
        return (
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={`/${USER_LANG}/production`}>
                            {gettext('Production')}
                        </Link>
                    </li>
                    <li className="breadcrumb-item active">
                        {text}
                    </li>
                </ol>
            </nav>
        );
    };

    render() {
        let content = null;
        if (this.props.error) {
            // Loading has failed
            content = <ErrorAlert>{this.props.error}</ErrorAlert>;
        } else if (this.props.isLoading) {
            // Loading in progress
            content = <LoadingSpinner />;
        } else if (this.props.product) {
            // Got a product
            content = (
                <div className="card">
                    <div className="card-body">
                        <ProductDetailsSection
                            product={this.props.product}
                            userId={this.props.userId}
                        />
                        {this.renderTimerButtons()}

                        <QualityControlFeedback
                            feedbackList={this.props.qualityControl.feedback}
                            isLoading={this.props.qualityControl.isLoading}
                        />

                        {this.renderComponents(this.props.product)}

                        <WorkLogs workLogs={this.props.workLogs} />
                    </div>
                </div>
            );
        }

        return (
            <div>
                {this.renderNavbar()}
                {content}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userId: state.workers.worker.id,
    workers: state.productDetail.workers,
    product: state.productDetail.product,
    error: state.productDetail.error,
    isLoading: state.productDetail.isLoading,
    workLogs: state.workLogs,
    showAddWorker: state.workers.worker.role === WORKERS.ROLES.BUNDLER.value,
    qualityControl: state.qualityControl,
});

const mapDispatchToProps = dispatch => ({
    refreshProduct: productId => dispatch(refreshProduct(productId)),
    fetchWorkLogs: (productId, userId) => dispatch(fetchWorkLogs(productId, userId)),
    fetchFeedback: productId => dispatch(fetchFeedback(productId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProductDetails);



// WEBPACK FOOTER //
// ./src/components/ProductDetail.js